import { render, staticRenderFns } from "./OxygenTagChooser.vue?vue&type=template&id=6486f832&"
import script from "./OxygenTagChooser.vue?vue&type=script&lang=ts&"
export * from "./OxygenTagChooser.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenTagChooser.vue?vue&type=style&index=0&id=6486f832&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports